/** @hidden */
var _DevTools = /** @class */ (function () {
    function _DevTools() {
    }
    _DevTools.WarnImport = function (name) {
        return name + " needs to be imported before as it contains a side-effect required by your code.";
    };
    return _DevTools;
}());
export { _DevTools };
//# sourceMappingURL=devTools.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Misc/devTools.js
// module id = N8l4
// module chunks = 0